export default function AdminModal({ title, onClose, children, width = '540px' }) {
  return (
    <div style={S.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={{ ...S.modal, maxWidth: width }}>
        <div style={S.header}>
          <h3 style={S.title}>{title}</h3>
          <button style={S.closeBtn} onClick={onClose}>✕</button>
        </div>
        <div style={S.body}>{children}</div>
      </div>
    </div>
  );
}

export function ConfirmModal({ message, onConfirm, onCancel, danger = true }) {
  return (
    <div style={S.overlay}>
      <div style={{ ...S.modal, maxWidth: '400px' }}>
        <div style={S.body}>
          <div style={{ fontSize: '36px', textAlign: 'center', marginBottom: '12px' }}>⚠️</div>
          <p style={{ fontWeight: 700, textAlign: 'center', marginBottom: '8px', fontSize: '16px' }}>Are you sure?</p>
          <p style={{ fontSize: '13px', color: '#666', textAlign: 'center', lineHeight: 1.7, marginBottom: '24px' }}>{message}</p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button style={S.cancelBtn} onClick={onCancel}>Cancel</button>
            <button style={{ ...S.confirmBtn, background: danger ? '#DC2626' : '#16A34A' }} onClick={onConfirm}>
              {danger ? 'Delete' : 'Confirm'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const S = {
  overlay:   { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', zIndex: 9000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', backdropFilter: 'blur(2px)' },
  modal:     { background: '#fff', width: '100%', borderRadius: '0', boxShadow: '0 20px 60px rgba(0,0,0,.3)', maxHeight: '90vh', display: 'flex', flexDirection: 'column', animation: 'none' },
  header:    { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 22px', borderBottom: '1px solid #E5E5E5', background: '#FAFAFA', flexShrink: 0 },
  title:     { fontFamily: 'var(--font-display)', fontSize: '15px', letterSpacing: '1.5px', color: '#111', margin: 0 },
  closeBtn:  { background: 'none', border: 'none', fontSize: '16px', cursor: 'pointer', color: '#888', padding: '4px 8px', lineHeight: 1 },
  body:      { padding: '22px', overflowY: 'auto' },
  cancelBtn: { padding: '9px 22px', background: '#fff', border: '1.5px solid #D1D5DB', color: '#374151', fontFamily: 'var(--font-body)', fontSize: '13px', fontWeight: 600, cursor: 'pointer' },
  confirmBtn:{ padding: '9px 22px', border: 'none', color: '#fff', fontFamily: 'var(--font-body)', fontSize: '13px', fontWeight: 700, cursor: 'pointer' },
};
